import React from 'react';

import PageContainer from '@/components/layout/PageContainer';
import { Skeleton } from '@/components/ui/skeleton';

const ActingDetailsSkeleton: React.FC = () => (
  <PageContainer title="Detalhes da Execução">
    <div className="grid gap-6 lg:grid-cols-3">
      <Skeleton className="h-64 lg:col-span-3" />
      <Skeleton className="h-[520px] lg:col-span-2" />
      <Skeleton className="h-[520px]" />
    </div>
  </PageContainer>
);

export default ActingDetailsSkeleton;
